import React from 'react';
import _isFunction from 'lodash/isFunction';

import Button from '@atoms/Button';
import ButtonType from '@atoms/Button/type';
import useCalculatorState from 'hooks/useCalculatorState';
import { IPropsWithClassName } from 'interfaces';

import styles from './styles';

export interface NextPrevButtonsProps extends IPropsWithClassName {
  nextButtonEnabled?: boolean;
  hideNext?: boolean;
  onNextButtonClick?():void;
}

const NextPrevButtons = ({
  nextButtonEnabled = false,
  hideNext = false,
  className,
  onNextButtonClick,
}: NextPrevButtonsProps) => {
  const {
    prevStep,
    nextStep,
    isFirstStep,
    isLastStep,
  } = useCalculatorState();

  const onNextClick = () => {
    if (_isFunction(onNextButtonClick)) {
      onNextButtonClick();
    } else {
      nextStep();
    }
  };

  const nextStepButton = (
    <Button
      className="w-full md:!mr-6 md:!w-auto"
      onClick={onNextClick}
      disabled={isLastStep() || !nextButtonEnabled}
    >
      Next Step
    </Button>
  );

  return (
    <div className={styles.component(className)}>
      <Button
        className="w-full !mb-6 md:!mb-0 md:!mr-6 md:!w-auto"
        type={ButtonType.SECONDARY}
        onClick={prevStep}
        disabled={isFirstStep()}
      >
        Previous Step
      </Button>

      {!hideNext && nextStepButton}
    </div>
  );
};

export default NextPrevButtons;
